import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';

import { GenericPageableResponse } from '@shared/models/GenericPageableResponse';
import { HttpHandlerService } from '@shared/services/http-handler.service';
import { ottUnpaginate } from '@shared/operators/paginate.operator';
import { StorageService } from '@shared/services/storage.service';
import { GenericResponse } from '@shared/models/GenericResponse';
import { DialogService } from '@shared/services/dialog.service';
import { ToastService } from '@shared/services/toast.service';
import { StringUtils } from '@shared/utils/string.utils';
import { ObjectUtils } from '@shared/utils/object.utils';
import { Company, SFCompany } from '@shared/models/Company';
import { KeyMap, PageableFilter } from '@shared/models/KeyMap';

const BASE_URL = `${environment.ticketsUrl}/api/v1/empresas`;

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    private http: HttpHandlerService,
    private storage: StorageService,
    private router: Router,
    private toast: ToastService,
    private dialog: DialogService
  ) {}

  public fetch(searchCriteria: PageableFilter<SFCompany>) {
    return this.http.request<GenericPageableResponse<SFCompany>>(BASE_URL)
                    .setParams(searchCriteria)
                    .setLoadingMessage('Buscando empresas')
                    .setErrorMessage('Falha ao buscar empresas')
                    .get();
  }

}
